import { queryGiftDetail } from "@/api/gift";
import TopNavigation from "@/components/top-navigation";
import { onShareAppMessageByHome } from "@/utils/actions";
import { usePageTitle } from "@/utils/page_utils";
import Track from "@/utils/track";
import useNavigation from "@/utils/useNavigate";
import { UserGiftDetailVO } from "@akc/biz-api";
import { GiftGroupBannerComp, GiftTipsCardComp } from "@akc/mx-taro-h5-components";
import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Filter from "./components/filter";
import Product from "./components/Product";
import { useProductsControl } from "./hook";
import styles from "./index.module.less";

const RewardGiftActivity: React.FC = () => {
  const [fixed, setFixed] = useState<boolean>(false);
  const [showLoading, setShowLoading] = useState<boolean>(true);
  const [giftDetail, setGiftDetail] = useState<UserGiftDetailVO>({});
  const headerRef = useRef<HTMLDivElement>(null);
  const filterRef = useRef<HTMLDivElement>(null);
  const track = Track();
  const [search] = useSearchParams();
  const { navigate2H5 } = useNavigation();
  const actId = search.get("actId") || "";
  const productsControl = useProductsControl(actId);

  usePageTitle("赠品活动");

  // 获取赠品活动数据
  const getGiftDetail = async () => {
    try {
      const res = await queryGiftDetail(actId) || {};
      setGiftDetail(res);
    } catch (error) {
      console.error(error);
    } finally {
      setShowLoading(false);
    }
  };
  useEffect(() => {
    getGiftDetail();
    onShareAppMessageByHome();
    track.track("$pageview", {
      page_name: "C满赠凑单页"
    });
  }, []);

  // 控制筛选模块吸顶
  useEffect(() => {
    const scrollContainer = document.getElementById("reward-gift-scrollview");
    if (scrollContainer) {
      const handleScroll = () => {
        const headerHeight = headerRef.current?.offsetHeight || 0;
        const scrollTop = scrollContainer.scrollTop;

        if (scrollTop >= headerHeight && giftDetail?.actId) {
          setFixed(true);
        } else {
          setFixed(false);
        }
      };
      scrollContainer.addEventListener("scroll", handleScroll);
      return () => {
        scrollContainer.removeEventListener("scroll", handleScroll);
      };
    }
  }, [giftDetail?.actId]);

  // 跳转到详细规则页面
  const goToDetailRule = () => {
    if (giftDetail.actRuleDescUrl) {
      navigate2H5(giftDetail.actRuleDescUrl);
    }
  };


  return (
    <div id="reward-gift-activity" className={styles.container}>
      {!fixed && (
        <>
          <div className={styles.topArea}>
            {/* 顶部导航栏 */}
            <TopNavigation
              hideSearchIcon={true}
              hideCartIcon={true}
              hideFavoriteIcon={true}
              backgroundColor={"transparent"}
            />
          </div>
          {/* 详细规则按钮 - 独立放置在最外层 */}
          {giftDetail.actRuleDescUrl && giftDetail.actRuleDescOpen && (
            <div
              className={styles.ruleButtonFixed}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                goToDetailRule();
              }}
            >
              <span>详细规则</span>
              <img
                src="https://akim-oss.aikucun.com/ed995cb8c759edffdd9be44821f63ecd411eda3e_1744080472043_5.png"
                className={styles.arrowIcon}
                alt="箭头"
              />
            </div>
          )}
        </>
      )}

      {/* 可滚动区域 */}
      <div
        id="reward-gift-scrollview"
        className={styles.scrollContainer}
      >
        {/* 头部loadding */}
        {showLoading && <div className={styles.couponBoardBg}>
          <div className={styles.couponBoardSkeleton}></div>
          <img
            src="https://akim-oss.aikucun.com/8fc652aeec7af24437a563ff2b4fefc9b3d10843_1744623507692_22.png"
            className={styles.couponBoardImg}
            alt="coupon"
          />
        </div>}
        {/* 头部区域 */}
        {giftDetail.actId && <div className={styles.headerWrapper} ref={headerRef}>
          <div className={styles.activityInfo}>
            {/* 订单满件送赠品 */}
            <div className={styles.ruleWrapper}>
              <GiftTipsCardComp
                giftDetail={giftDetail}
              />
            </div>

            {/* 赠品展示区 */}
            <div className={styles.giftShowcase}>
              <GiftGroupBannerComp
                rewardGifts={giftDetail?.ruleList}
                orientation='horizontal'
                swiperChildStyle={{
                  marginLeft: 6,
                  marginRight: 6
                }}
              />
            </div>
          </div>
        </div>}

        {/* 商品区域 */}
        <div className={styles.productWrapper} id="bottomBox">
          {/* 适用商品标题 */}
          <div className={styles.applicableTitle}>
            <img className={styles.titleDivider} src="https://akim-oss.aikucun.com/518edcdf460cd0094a1e816cbc116011c403c706_1743040439337_43.png" alt="" />
            <span>适用商品</span>
            <img className={styles.titleDivider} src="https://akim-oss.aikucun.com/518edcdf460cd0094a1e816cbc116011c403c706_1743040439337_43.png" alt="" />
          </div>

          {/* 筛选模块(可吸顶) */}
          <div className={`${styles.filterWrapper} ${fixed ? styles.fixed : ""}`} ref={filterRef}>
            <Filter
              filter={productsControl.filter}
              searchParams={productsControl.searchParams}
              fixed={fixed}
              setSearchParams={productsControl.setSearchParams}
              handleSearch={productsControl.handleSearch}
              brandList={productsControl.brandList}
              priceRangeList={productsControl.priceRangeList}
            />
          </div>

          {/* 商品瀑布流 */}
          <div className={styles.productList}>
            <Product
              handleSearch={productsControl.handleSearch}
              prodArr={productsControl.productList}
              hasNext={productsControl.hasNext}
              secondResourceClick={productsControl.secondResourceClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RewardGiftActivity;
